export const commonStyleDescriptionMixin = {
  methods: {
    /**
     * Call this function at mounted for change attributes in id or class from text editor to be commonly
     *
     * @param {String} id using with single element
     * @param {String} className using with multiple element
     */
    commonIdAttributes(Id) {
      const targetElement = document.getElementById(Id);

      if (targetElement) {
        let allDescriptionChilden = targetElement.querySelectorAll('*');

        allDescriptionChilden.forEach((element) => {
          const allAnchorTags = element.getElementsByTagName('a');

          if (allAnchorTags && allAnchorTags.length > 0) {
            allAnchorTags.forEach((a) => {
              a.style.textDecoration = 'underline';
            });
          }
          element.style.color = '';
          element.style.backgroundColor = '';
        });
      }
    },

    commonClassAttributes(className) {
      const descriptionElements = document.getElementsByClassName(className);
      descriptionElements.forEach((element) => {
        const childElements = element.querySelectorAll('*');
        if (childElements && childElements.length) {
          childElements.forEach((childElem) => {
            childElem.style.color = '';
            childElem.style.backgroundColor = '';
          });
        }
        if (element.getElementsByTagName('a').length) {
          const allAnchorTags = element.getElementsByTagName('a');
          allAnchorTags.forEach((a) => {
            a.style.textDecoration = 'underline';
          });
        }
      });
    }
  }
};
